<template>
	<div class="max-w-4xl px-4 sm:px-8 py-16 mx-auto flex flex-col gap-4 sm:gap-8">
		<slot />
	</div>
</template>
